import React, { useState } from 'react';
import { List } from 'antd';

const SingleSelect = ({ dataArr1, handleSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedItem, setSelectedItem] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const onUpdate = () => {
    if (selectedItem) {
      handleSelect(selectedItem);
      setSearchTerm('');
      setSelectedItem('');
    }
  };

  const onSelect = (item) => {
    setSelectedItem(item);
    setSearchTerm(item.fullName);
  };

  const handleOnCancel = () => {
    setSearchTerm('');
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {/* Input cho việc tìm kiếm */}
        <input
          placeholder={'Add member...'}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => setIsFocused(true)}
          autoFocus
          onBlur={() => setTimeout(() => setIsFocused(false), 200)}
        />
        <div>
          <button
            onClick={onUpdate}
            style={{
              marginRight: '8px',
              backgroundColor: '#000',
              color: '#0e9347',
              opacity: selectedItem ? 1 : 0.5,
              pointerEvents: selectedItem ? 'auto' : 'none',
            }}
          >
            Add
          </button>
          <button
            style={{ backgroundColor: '#000', color: '#4f4d4d' }}
            onClick={handleOnCancel}
          >
            Cancel
          </button>
        </div>
      </div>

      {/* Gợi ý danh sách thành viên */}
      {(isFocused || searchTerm) && (
        <List
          style={{
            marginTop: '10px',
            maxHeight: '200px',
            overflow: 'auto',
            opacity: '0.5',
          }}
          bordered
          dataSource={dataArr1.filter(
            (d) =>
              !searchTerm ||
              d.phonenumber.includes(searchTerm) ||
              d.fullName.toLowerCase().includes(searchTerm.toLowerCase())
          )}
          renderItem={(item) => (
            <List.Item
              onClick={() => onSelect(item)}
              style={{ cursor: 'pointer' }}
            >
              {item.phonenumber} - {item.fullName}
            </List.Item>
          )}
        />
      )}

      {/* Danh sách thành viên đã chọn */}
      {/* <div style={{ marginTop: '10px' }}>
        {selectedMembers.map((member) => (
          <Tag
            key={member.accountId}
            closable
            onClose={() => handleRemove(member.accountId)}
          >
            {member.fullName}
          </Tag>
        ))}
      </div> */}
    </div>
  );
};

export default SingleSelect;
